import React from 'react';
import PropTypes from 'prop-types';

import autobind from 'common/decorators/autobind.js';
import Icon from 'core/components/Icon.js';
import events from 'events.js';

export default class Button extends React.Component {
    static propTypes = {
        action: PropTypes.func.isRequired,
        customClass: PropTypes.string,
        customRef: PropTypes.oneOfType([
            PropTypes.object,
            PropTypes.shape({current: PropTypes.instanceOf(Element)}),
        ]),
        disabled: PropTypes.bool,
        gaObjectType: PropTypes.string,
        gaSelector: PropTypes.string,
        icon: PropTypes.string,
        isPreventDefault: PropTypes.bool,
        onKeyDown: PropTypes.func,
        text: PropTypes.oneOfType([PropTypes.string, PropTypes.object])
            .isRequired,
        title: PropTypes.string,
    };

    constructor(props) {
        super(props);
        this.ref = props.customRef || React.createRef();
    }

    static defaultProps = {
        disabled: false,
        type: 'button',
    };

    componentDidMount() {
        events.listen(this.ref.current, 'mousedown', this.handleMouseDown);
    }

    componentWillUnmount() {
        events.unlisten(this.ref.current, 'mousedown', this.handleMouseDown);
    }

    @autobind
    handleMouseDown(event) {
        if (this.props.preventDefault) {
            event.preventDefault();
        }
    }

    @autobind
    handleClick(event) {
        const {action, isPreventDefault} = this.props;
        if (isPreventDefault) {
            event.preventDefault();
        }
        action(event);
    }

    renderIcon() {
        const {icon} = this.props;
        if (icon) {
            return <Icon name={icon} />;
        }
        return null;
    }

    render() {
        const {
            customClass,
            disabled,
            gaObjectType,
            gaSelector,
            onKeyDown,
            text,
            title,
            type,
        } = this.props;
        return (
            <button
                data-ga-object-type={gaObjectType}
                data-ga-selector={gaSelector}
                className={customClass}
                disabled={disabled}
                onClick={this.handleClick}
                onKeyDown={onKeyDown}
                ref={this.ref}
                title={title ? title : undefined}
                type={type}
            >
                {this.renderIcon()}
                {text}
            </button>
        );
    }
}
